module.exports = __webpack_public_path__ + "static/media/de.5c9661f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lang/de.svg
// module id = 610
// module chunks = 0